import { Analytics } from '@util/Analytics';
import { translate } from '@util/Localization';
import React, { Dispatch, FunctionComponent } from 'react';
import styled from 'styled-components';
import { Color } from '../../config/Color';
import { LightContainer } from '../styles/ColoredContainers';

const ICON = {
  Up: '\u25B2',
  Down: '\u25BC',
};

type WhyNowProps = {
  isOpen: boolean;
};

type CreditCardWhyNowButtonProps = WhyNowProps & {
  setIsOpen: Dispatch<boolean>;
};

export const CreditCardWhyNowButton: FunctionComponent<CreditCardWhyNowButtonProps> = (props) => {
  function toggleOpen() {
    if (!props.isOpen) {
      Analytics.track({ event: Analytics.Event.o_credit_card_why_now_opened });
    }
    props.setIsOpen(!props.isOpen);
  }

  return (
    <ButtonContainer onClick={toggleOpen} data-test="whyNow">
      Why now? <ExpandIcon>{props.isOpen ? ICON.Up : ICON.Down}</ExpandIcon>
    </ButtonContainer>
  );
};

export const CreditCardWhyNowSection: FunctionComponent<WhyNowProps> = (props) => (
  <SectionContainer isOpen={props.isOpen} data-test="whyNowSection">
    {translate('payment.whyNow')}
  </SectionContainer>
);

const ExpandIcon = styled.span`
  font-size: 0.6em;
`;

const ButtonContainer = styled.div`
  flex: 0 0 1;
  font-size: ${({ theme }) => theme.fontSize.xs};
  text-align: right;
  cursor: pointer;
  color: ${Color.content.default};
`;

const SectionContainer = styled(LightContainer)<WhyNowProps>`
  max-height: ${({ isOpen }) => (isOpen ? '150px' : '0px')};
  margin-bottom: ${({ isOpen }) => (isOpen ? '16px' : '0px')};
  padding: ${({ isOpen }) => (isOpen ? '1.5em' : '0 1.5em')};
  opacity: ${({ isOpen }) => (isOpen ? '1' : '0.3')};
  text-align: left;
  overflow: hidden;
  transition: all 200ms;
  color: ${Color.content.default};
`;
